"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Collapse_1 = __importDefault(require("@mui/material/Collapse"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
var DesktopWindowsOutlined_1 = __importDefault(require("@mui/icons-material/DesktopWindowsOutlined"));
var SmartphoneOutlined_1 = __importDefault(require("@mui/icons-material/SmartphoneOutlined"));
var ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
var axios_1 = __importDefault(require("axios"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
var Toast_1 = __importStar(require("../Generic/Toast"));
var usePreferencesState_1 = __importDefault(require("../Notifications/hooks/usePreferencesState"));
var api_1 = require("../Notifications/api");
var preferencesStore_1 = require("../Notifications/storage/preferencesStore");
// TODO WHEN mobile push launches on production: strip out the mobilePrefEnabled guard
var bootstrap_1 = require("../Notifications/bootstrap");
var unique = function (arr) { return Array.from(new Set(arr)); };
// Surface a provider/control message only when it reads as user-facing text;
// hide empty values and the bare 'Failed' sentinel so the UI shows the list
// name alone rather than noise.
var friendlyMessage = function (raw) {
    var msg = (raw !== null && raw !== void 0 ? raw : '').trim();
    if (!msg || msg.toLowerCase() === 'failed')
        return '';
    return msg;
};
// A kind only supports a channel if its config lists it (default-on, matching KindChannelToggles).
var kindSupports = function (kind, channel) {
    var _a, _b;
    var kc = (0, preferencesStore_1.getKinds)().find(function (k) { return k.kind === kind; });
    return (_b = (_a = kc === null || kc === void 0 ? void 0 : kc.channels) === null || _a === void 0 ? void 0 : _a.includes(channel)) !== null && _b !== void 0 ? _b : true;
};
// Module-scope (not declared inside the parent) so its identity is stable across
// renders — otherwise React would remount the Switch and lose the on/off animation.
function ChannelToggle(_a) {
    var icon = _a.icon, label = _a.label, tooltip = _a.tooltip, checked = _a.checked, mixed = _a.mixed, disabled = _a.disabled, onChange = _a.onChange;
    return (react_1.default.createElement(Tooltip_1.default, { title: tooltip, placement: "top" },
        react_1.default.createElement("span", null,
            react_1.default.createElement(FormControlLabel_1.default, { className: "msia-prefToggle", sx: { m: 0 }, control: react_1.default.createElement(Switch_1.default, { size: "small", checked: checked, onChange: function (e) { return onChange(e.target.checked); }, disabled: disabled, 
                    // "Mixed" = some-but-not-all underlying lists are on. Park the thumb
                    // mid-track in the warning colour so it reads as a true third state,
                    // distinct from both off (grey, left) and on (primary, right).
                    sx: mixed ? {
                        '& .MuiSwitch-switchBase': { transform: 'translateX(8px)', color: 'warning.main' },
                        '& .MuiSwitch-thumb': { backgroundColor: 'warning.main' },
                        '& .MuiSwitch-track': { backgroundColor: 'warning.main', opacity: 0.5 },
                    } : undefined }), label: react_1.default.createElement(Stack_1.default, { direction: "row", spacing: 0.5, alignItems: "center", sx: disabled ? { opacity: 0.45 } : undefined },
                    icon,
                    react_1.default.createElement("span", null, label)) }))));
}
// Shared column template so the org-header master toggles line up exactly over
// the per-list toggles beneath them: List | Email | Web | Mobile.
// Responsive: on sm+ the four columns align master toggles over per-list toggles
// (List | Email | Web | Mobile). On xs the list/title spans the full width and the
// three toggles drop to their own equal-width row beneath, so nothing overlaps.
var GRID_COLS = { xs: 'repeat(3, minmax(0, 1fr))', sm: 'minmax(0, 1fr) repeat(3, minmax(92px, 120px))' };
// First grid cell (list details / org title) spans all three columns on xs.
var FIRST_CELL_SPAN = { gridColumn: { xs: '1 / -1', sm: 'auto' } };
function GetSubscriptions() {
    var _this = this;
    var _a = (0, react_1.useState)({}), subscriptions = _a[0], setSubscriptions = _a[1];
    var _b = (0, react_1.useState)({}), isChecked = _b[0], setChecked = _b[1];
    var _c = (0, react_1.useState)({}), showSpinner = _c[0], setShowSpinner = _c[1];
    var _d = (0, react_1.useState)({}), showResendConfirm = _d[0], setResendConfirm = _d[1];
    var _e = (0, react_1.useState)((0, preferencesStore_1.isPreferencesInitialised)()), prefsReady = _e[0], setPrefsReady = _e[1];
    var _f = (0, react_1.useState)({}), openOrgs = _f[0], setOpenOrgs = _f[1];
    var _g = (0, react_1.useState)({}), orgBusy = _g[0], setOrgBusy = _g[1];
    var _h = (0, react_1.useState)(null), confirmOff = _h[0], setConfirmOff = _h[1];
    var userId = (0, react_1.useMemo)(function () {
        var _a;
        var el = document.getElementById('subscriptions-list');
        return parseInt((_a = el === null || el === void 0 ? void 0 : el.dataset.userId) !== null && _a !== void 0 ? _a : '0', 10);
    }, []);
    var isEnabled = (0, usePreferencesState_1.default)(userId).isEnabled;
    var mobileEnabled = (0, bootstrap_1.mobilePrefEnabled)();
    (0, react_1.useEffect)(function () {
        if (!(0, preferencesStore_1.isPreferencesInitialised)()) {
            void (0, api_1.fetchAndInitPreferences)().then(function () { return setPrefsReady(true); });
        }
    }, []);
    // Avoid shadowing imported `lang`
    var docLang = (0, react_1.useMemo)(function () { return document.documentElement.getAttribute('lang') || 'en_US'; }, []);
    var requestLang = docLang || Lang_js_1.lang || 'en_US';
    var subscriptionIds = (0, react_1.useMemo)(function () { return Object.keys(subscriptions || {}); }, [subscriptions]);
    // Group by org and order sections by orgOrder. Object key order is not reliable
    // here (numeric-string keys sort numerically), so groups are sorted explicitly.
    var orgGroups = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        var byOrg = {};
        for (var _i = 0, subscriptionIds_1 = subscriptionIds; _i < subscriptionIds_1.length; _i++) {
            var key = subscriptionIds_1[_i];
            var sub = subscriptions[key];
            var org = (_a = sub === null || sub === void 0 ? void 0 : sub.org) !== null && _a !== void 0 ? _a : 'msia';
            if (!byOrg[org]) {
                byOrg[org] = {
                    org: org,
                    orgLabel: (_b = sub === null || sub === void 0 ? void 0 : sub.orgLabel) !== null && _b !== void 0 ? _b : org,
                    orgOrder: (_c = sub === null || sub === void 0 ? void 0 : sub.orgOrder) !== null && _c !== void 0 ? _c : Number.MAX_SAFE_INTEGER,
                    keys: [],
                };
            }
            byOrg[org].keys.push(key);
        }
        // Order lists within each org by title so the order is deterministic rather
        // than dependent on JSON object-key order.
        for (var _d = 0, _e = Object.values(byOrg); _d < _e.length; _d++) {
            var group = _e[_d];
            group.keys.sort(function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = subscriptions[a]) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '').localeCompare((_d = (_c = subscriptions[b]) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : ''); });
        }
        return Object.values(byOrg).sort(function (a, b) { return a.orgOrder - b.orgOrder; });
    }, [subscriptions, subscriptionIds]);
    // Default the first (highest-priority) org open, the rest collapsed.
    (0, react_1.useEffect)(function () {
        if (orgGroups.length === 0)
            return;
        setOpenOrgs(function (prev) {
            var _a;
            return (Object.keys(prev).length > 0 ? prev : (_a = {}, _a[orgGroups[0].org] = true, _a));
        });
    }, [orgGroups]);
    var resolveListIdForApi = function (key, subscription) {
        if (subscription && subscription.id !== undefined && subscription.id !== null && "".concat(subscription.id) !== '') {
            return "".concat(subscription.id);
        }
        return "".concat(key);
    };
    var deriveCheckedFromStatus = function (status) { return status === 'Active'; };
    var setSpinnerFor = function (key, value) {
        setShowSpinner(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var setResentFor = function (key, value) {
        setResendConfirm(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var updateSubscriptionStatus = function (key, newStatus) {
        setSubscriptions(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = __assign(__assign({}, prev[key]), { status: newStatus }), _a)));
        });
    };
    var setCheckedFor = function (key, value) {
        setChecked(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var setOrgBusyFor = function (org, value) {
        setOrgBusy(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[org] = value, _a)));
        });
    };
    var toggleOrgOpen = function (org) {
        setOpenOrgs(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[org] = !prev[org], _a)));
        });
    };
    var toastListFailure = function (title, rawMessage) {
        var detail = friendlyMessage(rawMessage);
        (0, Toast_1.toast)({
            message: "".concat((0, Lang_js_1.__)("Couldn't update"), " ").concat(title).concat(detail ? ": ".concat(detail) : ''),
            severity: 'warning',
            autoHideMs: 6000,
        });
    };
    var switchToggle = function (key, subscription) { return __awaiter(_this, void 0, void 0, function () {
        var listIdForApi, currentlyChecked, url, response_1, response, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    listIdForApi = resolveListIdForApi(key, subscription);
                    currentlyChecked = !!isChecked[key] || subscription.status === 'Active';
                    setSpinnerFor(key, true);
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 5, , 6]);
                    if (!currentlyChecked) return [3 /*break*/, 3];
                    url = "/api/subscriptions?lang=".concat(encodeURIComponent(requestLang), "&listid=").concat(encodeURIComponent(listIdForApi));
                    return [4 /*yield*/, axios_1.default.delete(url)];
                case 2:
                    response_1 = _l.sent();
                    setSpinnerFor(key, false);
                    if (((_a = response_1.data) === null || _a === void 0 ? void 0 : _a.status) === 'success') {
                        setCheckedFor(key, false);
                        updateSubscriptionStatus(key, 'Unsubscribed');
                        return [2 /*return*/, true];
                    }
                    console.warn(((_c = (_b = response_1.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.Message) || response_1.data);
                    toastListFailure(subscription.title, (_e = (_d = response_1.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.Message);
                    return [2 /*return*/, false];
                case 3: return [4 /*yield*/, axios_1.default.post('/api/subscriptions', { listid: listIdForApi, lang: requestLang })];
                case 4:
                    response = _l.sent();
                    setSpinnerFor(key, false);
                    if (((_f = response.data) === null || _f === void 0 ? void 0 : _f.status) === 'success') {
                        // Only Campaign Monitor double-opt-ins send a confirmation email. Mailchimp
                        // subscribes immediately, so an Unconfirmed state there tells the member to
                        // watch for mail that never arrives.
                        if (subscription.type === 'OptIn' && subscription.provider !== 'mc') {
                            updateSubscriptionStatus(key, 'Unconfirmed');
                        }
                        else {
                            setCheckedFor(key, true);
                            updateSubscriptionStatus(key, 'Active');
                        }
                        return [2 /*return*/, true];
                    }
                    console.warn(((_h = (_g = response.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.Message) || response.data);
                    toastListFailure(subscription.title, (_k = (_j = response.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.Message);
                    return [2 /*return*/, false];
                case 5:
                    error_1 = _l.sent();
                    setSpinnerFor(key, false);
                    console.warn(error_1);
                    toastListFailure(subscription.title);
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Batch-set a row's Web (database) or Mobile (push) channel across all its kinds.
    // updatePreferences toasts and reconciles the store, which animates the switch.
    var toggleRowChannel = function (rowKinds, channel, enabled) {
        if (rowKinds.length === 0)
            return;
        void (0, api_1.updatePreferences)(rowKinds.map(function (kind) { return ({ kind: kind, channel: channel, enabled: enabled }); }));
    };
    var resolveTitleById = function (id) {
        var _a;
        var sid = String(id);
        var key = subscriptionIds.find(function (k) { var _a, _b; return String((_b = (_a = subscriptions[k]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : k) === sid; });
        return (key && ((_a = subscriptions[key]) === null || _a === void 0 ? void 0 : _a.title)) || "#".concat(sid);
    };
    // Reconcile the (locally-held) email column from a bulk response's `changed[]`.
    var applyChangedStatuses = function (changed) {
        if (!changed.length)
            return;
        var byId = {};
        for (var _i = 0, changed_1 = changed; _i < changed_1.length; _i++) {
            var c = changed_1[_i];
            byId[String(c.id)] = c.status;
        }
        setSubscriptions(function (prev) {
            var _a, _b;
            var next = __assign({}, prev);
            for (var _i = 0, _c = Object.keys(next); _i < _c.length; _i++) {
                var key = _c[_i];
                var id = String((_b = (_a = next[key]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : key);
                if (byId[id] !== undefined)
                    next[key] = __assign(__assign({}, next[key]), { status: byId[id] });
            }
            return next;
        });
        setChecked(function (prev) {
            var _a, _b;
            var next = __assign({}, prev);
            for (var _i = 0, _c = Object.keys(subscriptions); _i < _c.length; _i++) {
                var key = _c[_i];
                var id = String((_b = (_a = subscriptions[key]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : key);
                if (byId[id] !== undefined)
                    next[key] = byId[id] === 'Active';
            }
            return next;
        });
    };
    var performEmailMaster = function (org, orgLabel, enabled) { return __awaiter(_this, void 0, void 0, function () {
        var res, parts, prefix, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOrgBusyFor(org, true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, api_1.bulkSetSubscriptionChannel)({ org: org, channel: 'email', enabled: enabled, lang: requestLang })];
                case 2:
                    res = _a.sent();
                    applyChangedStatuses(res.changed);
                    if (res.failed.length) {
                        parts = res.failed.map(function (f) {
                            var detail = friendlyMessage(f.message);
                            return "".concat(resolveTitleById(f.id)).concat(detail ? ": ".concat(detail) : '');
                        });
                        prefix = res.changed.length
                            ? "".concat((0, Lang_js_1.__)('Updated'), " ").concat(res.changed.length, ". ").concat((0, Lang_js_1.__)("Couldn't update"))
                            : (0, Lang_js_1.__)("Couldn't update");
                        (0, Toast_1.toast)({ message: "".concat(prefix, " ").concat(parts.join('; ')), severity: 'warning', autoHideMs: 8000 });
                    }
                    else {
                        (0, Toast_1.toast)({
                            message: "".concat(enabled ? (0, Lang_js_1.__)('Subscribed to all') : (0, Lang_js_1.__)('Unsubscribed from all'), " ").concat(orgLabel),
                            severity: 'success',
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.warn(error_2);
                    (0, Toast_1.toast)({ message: (0, Lang_js_1.__)('Update failed'), severity: 'error' });
                    return [3 /*break*/, 5];
                case 4:
                    setOrgBusyFor(org, false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var performChannelMaster = function (org, channel, enabled) { return __awaiter(_this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOrgBusyFor(org, true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, api_1.bulkSetSubscriptionChannel)({ org: org, channel: channel, enabled: enabled, lang: requestLang })];
                case 2:
                    _a.sent();
                    (0, Toast_1.toast)({ message: (0, Lang_js_1.__)('Notification preferences updated successfully'), severity: 'success' });
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    console.warn(error_3);
                    (0, Toast_1.toast)({ message: (0, Lang_js_1.__)('Update failed'), severity: 'error' });
                    return [3 /*break*/, 5];
                case 4:
                    setOrgBusyFor(org, false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Email-off is the only destructive master action — confirm it first.
    var onMasterEmail = function (group, enabled) {
        if (!enabled) {
            setConfirmOff({ org: group.org, orgLabel: group.orgLabel });
            return;
        }
        void performEmailMaster(group.org, group.orgLabel, true);
    };
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/subscriptions?lang=".concat(encodeURIComponent(requestLang)))
            .then(function (response) {
            var _a;
            var data = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || {};
            setSubscriptions(data);
            setChecked(function (prev) {
                var _a;
                var next = __assign({}, prev);
                for (var _i = 0, _b = Object.keys(data); _i < _b.length; _i++) {
                    var key = _b[_i];
                    if (typeof next[key] === 'undefined') {
                        next[key] = deriveCheckedFromStatus((_a = data[key]) === null || _a === void 0 ? void 0 : _a.status);
                    }
                }
                return next;
            });
        })
            .catch(function (error) { console.warn(error); });
    }, [requestLang]);
    if (!subscriptions || subscriptionIds.length === 0) {
        return react_1.default.createElement(Typography_1.default, null, "Loading...");
    }
    var emailIcon = react_1.default.createElement(EmailOutlined_1.default, { fontSize: "small" });
    var webIcon = react_1.default.createElement(DesktopWindowsOutlined_1.default, { fontSize: "small" });
    var mobileIcon = react_1.default.createElement(SmartphoneOutlined_1.default, { fontSize: "small" });
    var renderRow = function (key, busy) {
        var _a, _b;
        var sub = subscriptions[key];
        var kinds = (_a = sub === null || sub === void 0 ? void 0 : sub.notificationKinds) !== null && _a !== void 0 ? _a : [];
        var isUnconfirmed = sub.status === 'Unconfirmed';
        var webKinds = kinds.filter(function (k) { return kindSupports(k, 'database'); });
        var pushKinds = kinds.filter(function (k) { return kindSupports(k, 'push'); });
        var webApplicable = prefsReady && webKinds.length > 0;
        var rowWebChecked = webApplicable && webKinds.every(function (k) { return isEnabled(k, 'database'); });
        var mobileApplicable = prefsReady && mobileEnabled && pushKinds.length > 0;
        var rowMobileChecked = mobileApplicable && pushKinds.every(function (k) { return isEnabled(k, 'push'); });
        var emailLabel = (_b = (0, preferencesStore_1.getKinds)().find(function (g) { return g.kind === kinds[0]; })) === null || _b === void 0 ? void 0 : _b.title;
        return (react_1.default.createElement(Box_1.default, { key: key, sx: {
                display: 'grid',
                gridTemplateColumns: GRID_COLS,
                alignItems: 'center',
                columnGap: 1,
                rowGap: 1,
                py: 1.25,
                borderTop: '1px solid',
                borderColor: 'divider',
            } },
            react_1.default.createElement(Box_1.default, { sx: FIRST_CELL_SPAN },
                react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h4" }, sub.title),
                react_1.default.createElement(Typography_1.default, { component: "p", variant: "body2", dangerouslySetInnerHTML: { __html: sub.description } }),
                showSpinner[key] && react_1.default.createElement(LinearProgress_1.default, { sx: { mt: 1, maxWidth: 240 } }),
                isUnconfirmed && (react_1.default.createElement(Stack_1.default, { direction: "row", spacing: 1, alignItems: "center", sx: { mt: 0.75 } },
                    react_1.default.createElement(Typography_1.default, { variant: "caption", color: "warning.main" }, (0, Lang_js_1.__)('Check your email to confirm')),
                    showResendConfirm[key] ? (react_1.default.createElement(Typography_1.default, { variant: "caption", color: "success.main" }, '✔ ' + (0, Lang_js_1.__)('Sent'))) : (react_1.default.createElement(Button_1.default, { size: "small", sx: { px: 0, minWidth: 0, fontSize: 'inherit' }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, switchToggle(key, sub)];
                                    case 1:
                                        _a.sent();
                                        setResentFor(key, true);
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, (0, Lang_js_1.__)('Resend')))))),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } },
                react_1.default.createElement(ChannelToggle, { icon: emailIcon, label: (0, Lang_js_1.__)('Email'), tooltip: "".concat((0, Lang_js_1.__)('Receive emails from the list'), ": ").concat(sub.title), checked: !!isChecked[key] || isUnconfirmed, disabled: busy || showSpinner[key], onChange: function () { return switchToggle(key, sub); } })),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } }, webApplicable ? (react_1.default.createElement(ChannelToggle, { icon: webIcon, label: (0, Lang_js_1.__)('Web'), tooltip: emailLabel ? "".concat((0, Lang_js_1.__)('Show in your web inbox'), ": ").concat(emailLabel) : (0, Lang_js_1.__)('Show in your web inbox'), checked: rowWebChecked, disabled: busy, onChange: function (c) { return toggleRowChannel(webKinds, 'database', c); } })) : (react_1.default.createElement(Tooltip_1.default, { title: (0, Lang_js_1.__)('No web inbox notifications for this list') },
                react_1.default.createElement(Typography_1.default, { variant: "caption", color: "text.disabled" }, "\u2014")))),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } }, prefsReady && pushKinds.length > 0 ? (react_1.default.createElement(ChannelToggle, { icon: mobileIcon, label: (0, Lang_js_1.__)('Mobile'), tooltip: mobileEnabled ? (0, Lang_js_1.__)('Send push notifications to your mobile device') : (0, Lang_js_1.__)('Coming soon'), checked: rowMobileChecked, disabled: busy || !mobileEnabled, onChange: function (c) { return toggleRowChannel(pushKinds, 'push', c); } })) : (react_1.default.createElement(Tooltip_1.default, { title: (0, Lang_js_1.__)('No mobile notifications for this list') },
                react_1.default.createElement(Typography_1.default, { variant: "caption", color: "text.disabled" }, "\u2014"))))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toast_1.default, null),
        orgGroups.map(function (group) {
            var busy = !!orgBusy[group.org];
            var open = !!openOrgs[group.org];
            var orgKeys = group.keys;
            // Email master: on when every list in the org is on (Unconfirmed counts as on).
            var emailOnKeys = orgKeys.filter(function (k) { var _a; return !!isChecked[k] || ((_a = subscriptions[k]) === null || _a === void 0 ? void 0 : _a.status) === 'Unconfirmed'; });
            var emailAllOn = orgKeys.length > 0 && emailOnKeys.length === orgKeys.length;
            var emailMixed = emailOnKeys.length > 0 && emailOnKeys.length < orgKeys.length;
            // Web master: over the union of the org's database-capable kinds.
            var orgWebKinds = unique(orgKeys.flatMap(function (k) { var _a, _b; return ((_b = (_a = subscriptions[k]) === null || _a === void 0 ? void 0 : _a.notificationKinds) !== null && _b !== void 0 ? _b : []).filter(function (kk) { return kindSupports(kk, 'database'); }); }));
            var webOn = orgWebKinds.filter(function (k) { return isEnabled(k, 'database'); }).length;
            var webApplicable = prefsReady && orgWebKinds.length > 0;
            var webAllOn = webApplicable && webOn === orgWebKinds.length;
            var webMixed = webApplicable && webOn > 0 && webOn < orgWebKinds.length;
            // Mobile master: over the union of the org's push-capable kinds.
            var orgPushKinds = unique(orgKeys.flatMap(function (k) { var _a, _b; return ((_b = (_a = subscriptions[k]) === null || _a === void 0 ? void 0 : _a.notificationKinds) !== null && _b !== void 0 ? _b : []).filter(function (kk) { return kindSupports(kk, 'push'); }); }));
            var pushOn = orgPushKinds.filter(function (k) { return isEnabled(k, 'push'); }).length;
            var mobileApplicable = prefsReady && mobileEnabled && orgPushKinds.length > 0;
            var mobileAllOn = mobileApplicable && pushOn === orgPushKinds.length;
            var mobileMixed = mobileApplicable && pushOn > 0 && pushOn < orgPushKinds.length;
            return (react_1.default.createElement(Box_1.default, { key: group.org, component: "section", sx: { mb: 3 } },
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'grid',
                        gridTemplateColumns: GRID_COLS,
                        alignItems: 'center',
                        columnGap: 1,
                        rowGap: 1,
                        py: 1,
                        borderBottom: '2px solid',
                        borderColor: 'divider',
                    } },
                    react_1.default.createElement(Box_1.default, { sx: __assign(__assign({}, FIRST_CELL_SPAN), { display: 'flex', alignItems: 'center', cursor: 'pointer' }), onClick: function () { return toggleOrgOpen(group.org); } },
                        react_1.default.createElement(IconButton_1.default, { size: "small", "aria-label": open ? (0, Lang_js_1.__)('Collapse') : (0, Lang_js_1.__)('Expand'), sx: { mr: 0.5 } },
                            react_1.default.createElement(ChevronRight_1.default, { sx: { transform: open ? 'rotate(90deg)' : 'none', transition: 'transform .2s' } })),
                        react_1.default.createElement(Typography_1.default, { variant: "h5", component: "h3" }, group.orgLabel)),
                    react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement(ChannelToggle, { icon: emailIcon, label: (0, Lang_js_1.__)('Email'), tooltip: emailAllOn ? (0, Lang_js_1.__)('Unsubscribe from all') : (0, Lang_js_1.__)('Subscribe to all'), checked: emailAllOn, mixed: emailMixed, disabled: busy, onChange: function (c) { return onMasterEmail(group, c); } })),
                    react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement(ChannelToggle, { icon: webIcon, label: (0, Lang_js_1.__)('Web'), tooltip: (0, Lang_js_1.__)('Show all in your web inbox'), checked: webAllOn, mixed: webMixed, disabled: busy || !webApplicable, onChange: function (c) { return performChannelMaster(group.org, 'web', c); } })),
                    react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement(ChannelToggle, { icon: mobileIcon, label: (0, Lang_js_1.__)('Mobile'), tooltip: mobileEnabled ? (0, Lang_js_1.__)('Send all to your mobile device') : (0, Lang_js_1.__)('Coming soon'), checked: mobileAllOn, mixed: mobileMixed, disabled: busy || !mobileApplicable, onChange: function (c) { return performChannelMaster(group.org, 'mobile', c); } }))),
                busy && react_1.default.createElement(LinearProgress_1.default, null),
                react_1.default.createElement(Collapse_1.default, { in: open, timeout: "auto", unmountOnExit: true }, orgKeys.map(function (key) { return renderRow(key, busy); }))));
        }),
        react_1.default.createElement(Dialog_1.default, { open: confirmOff !== null, onClose: function () { return setConfirmOff(null); } },
            react_1.default.createElement(DialogTitle_1.default, null, (0, Lang_js_1.__)('Confirm unsubscribe')),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(DialogContentText_1.default, null, confirmOff
                    ? "".concat((0, Lang_js_1.__)('Unsubscribe from all emails from'), " ").concat(confirmOff.orgLabel, "? ").concat((0, Lang_js_1.__)('You will stop receiving them and may need to re-confirm to resubscribe.'))
                    : '')),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { onClick: function () { return setConfirmOff(null); } }, (0, Lang_js_1.__)('Cancel')),
                react_1.default.createElement(Button_1.default, { color: "error", variant: "contained", onClick: function () {
                        if (confirmOff) {
                            var target = confirmOff;
                            setConfirmOff(null);
                            void performEmailMaster(target.org, target.orgLabel, false);
                        }
                    } }, (0, Lang_js_1.__)('Unsubscribe'))))));
}
exports.default = GetSubscriptions;
var subscriptionsListEl = document.getElementById('subscriptions-list');
if (subscriptionsListEl) {
    (0, mountIsland_1.mountIsland)(subscriptionsListEl, react_1.default.createElement(GetSubscriptions, null));
}
